import React, { useEffect } from 'react'
import { OptionsHOC } from '../../hocs'
import { useAppContext } from '../App/Context'
import { replaceScriptNodes } from '../../helpers/utils'

const BotContainer = ({ getOptionObject }) => {
  const { language, customer } = useAppContext()

  useEffect(() => {
    const botOptions = getOptionObject('bot')

    if (botOptions.override) {
      const scriptsDomElement = document.getElementById('scripts')
      scriptsDomElement.insertAdjacentHTML('beforeend', botOptions.override)
      // this is needed to execute the script, if not it will be ignored
      replaceScriptNodes(scriptsDomElement)

      return
    }

    if (!botOptions.name) {
      return
    }

    window.loadScript(botOptions.bundleUrl, () => {
      window.DbChatWidget.init({
        ...botOptions,
        backend: botOptions.backend || 'botapi',
        botId: botOptions.name,
        botName: botOptions.trackingName || botOptions.name,
        launcher: {
          icon: botOptions.launcherIcon,
          minimizedIcon: botOptions.launcherMinimizedIcon
        },
        language,
        customer
      })
    })
  }, [])

  return <div id="db-chat-widget-root" />
}

export default OptionsHOC(BotContainer)



// WEBPACK FOOTER //
// ./src/containers/Bot/Bot.js